export enum SupportedLanguage {
    DE_DE = 'de-DE',
    EN = 'en',
    EN_UK = 'en-UK',
    ES_ES = 'es-ES',
    JA = 'ja',
    ZH_TW = 'zh-TW',
    ZH_CN = 'zh-CN',
    UK_UA = 'uk-UA',
    ID = 'id',
    ZH_HK = 'zh-HK',
    TH = 'th',
    KO = 'ko',
    VI = 'vi',
}
